import { PlatformType } from 'data/PlatformType';
import mixpanel from 'mixpanel-browser';
import { isRunningInProduction } from '.';
const gtag = (window as any).gtag;
const Sentry = (window as any).Sentry;

export const trackEvent = (eventName: string, data: object = {}) => {
  if (mixpanel) {
    const platform = (window as any).beatflyerPlatform as PlatformType;
    const plan = (window as any).beatflyerPlan;
    const deviceModel = (window as any).beatflyerDeviceModel;
    data = {
      ...data,
      plan,
      platform,
      deviceModel
    };
    mixpanel.track(eventName, data);
    // gtag('event', action, {
    //   event_category: category,
    //   event_label: label
    // });
  }
  if (!isRunningInProduction()) {
    console.log(`Track event "${eventName}" with data:`);
    console.log(data);
  }
};

export const identify = (userEmail: string) => {
  mixpanel.identify(userEmail);
};

export const trackPageChange = (path: string) => {
  if (gtag) {
    gtag('config', 'UA-107141482-1', { page_path: path });
    // gtag('event', 'page_view'); // didn't work
  } else {
    console.log('DEV Page Tracking: ' + path);
  }
};

export const reportBFError = (error: Error) => {
  if (Sentry) {
    Sentry.captureException(error);
  }
  console.error(error);
};

export const reportIssue = (message: string) => {
  if (Sentry) {
    Sentry.captureMessage(message);
  }
  console.error(message);
};



// WEBPACK FOOTER //
// ./src/utils/Tracker.ts